import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../Homepage/TravelSolution/TravelSolution.css";
import './OurTourismServices.css'

const OurTourismServices = () => {
  const solutionsData = [
    {
      title: "BLEISURE TRAVEL",
      description: "Looking to combine business and leisure travel? We're here to help you out—we offer a wide variety of packages that'll provide you with the flexibility to enjoy your trip right when you're done with your business meetings.",
      checklistItems: [
        "Travel & Accommodation",
        "Sightseeing with a Professional Guide",
        "   Space & IT Arrangements for Business "
      ],
      image: "https://blueberrywebsites.azureedge.net/bbt/images/Travel%20C.png",
      sectionClass: "first-section"
    },
    {
      title: "M.I.C.E. Travel",
      description: "Now you can organize your M.I.C.E. (Meetings, Incentives, Conferences, and Exhibitions) travels hassle-free. At Blueberry Travels, we are dedicated to offering top-notch travel services—from planning your travels to accommodations.",
      checklistItems: [
        "  Last-minute travel and transfers",
        "  Flexibility in Bookings ",
        "Accommodation"
      ],
      image: "https://blueberrywebsites.azureedge.net/bbt/images/Corporate%20T.png",
      sectionClass: "second-section"
    },
    {
      title: "EDUCATIONAL TRAVEL",
      description: "We are thoroughly invested in educational travel, also known as edutourism. Whether you are a student or a researcher, our educational travel services can offer you a great deal of exposure.",
      checklistItems: [
        "Educational Experience with Expert Guidance",
        " Cultural, Scientific, and Historical Excursions",
        " Student Exchange Programs with Universities"
      ],
      image: "https://blueberrywebsites.azureedge.net/bbt/images/Corporate%20M.png",
      sectionClass: "third-section"
    },
    {
      title: "GROUP TRAVEL",
      description: "Traveling with a group of family, friends, or colleagues? Whatever the occasion is, we are here to assist you throughout your journey. From itineraries to accommodations, our group travel packages cover everything.",
      checklistItems: [
        "  Thoroughly Planned Itineraries",
        "   Activities Tailored to Group Requirements",
        " Systematic Travel and Accommodations"
      ],
      image: "https://blueberrywebsites.azureedge.net/bbt/images/Procurement.png",
      sectionClass: "fourth-section"
    },
    {
        title: "FIXED DEPARTURES",
        description: "Are you traveling solo, with your partner, or in a small group? Well, in that case, our fixed departure packages are the most suitable ones for you. All you need to do is book a package that aligns with your plans, and voila!",
        checklistItems: [
          "Meticulously Curated Travel Packages",
          "Seamless Travels and Stays",
          " Expert-Led Tours"
        ],
        image: "https://blueberrywebsites.azureedge.net/bbt/images/Procurement.png",
        sectionClass: "fourth-section"
      },
      {
        title: "CRUISE TRAVEL",
        description: "Want to do something different this time? What about a luxurious cruise travel experience? Imagine watching beautiful sunrises and sunsets, all while enjoying lavish amenities.",
        checklistItems: [
          "  Buffet and Fine Dining Options",
          "   Onboard Entertainment",
          " Wide Range of Cruise Travel Packages"
        ],
        image: "https://blueberrywebsites.azureedge.net/bbt/images/Procurement.png",
        sectionClass: "fourth-section"
      },
      {
        title: "DESTINATION EVENTS",
        description: "Are you planning a destination event? Be it a corporate event or a wedding, we have got you covered. You choose the venue and leave the rest to us.",
        checklistItems: [
          "Travel Arrangements for All",
          "Hassle-Free Coordination",
          "Accommodation Facilities"
        ],
        image: "https://blueberrywebsites.azureedge.net/bbt/images/Procurement.png",
        sectionClass: "fourth-section"
      },
      {
        title: "GLOBAL VISA ASSISTANCE",
        description: "So, you know which country you want to visit but aren’t sure about how to get a visa? Don’t worry. Blueberry Travels is here to help. Irrespective of your nationality and the country you wish to travel to, you can contact us for visa assistance.",
        checklistItems: [
          "  Visa Assistance for All Countries",
          " 100% Confidentiality",
          " Hassle-Free Documentation"
        ],
        image: "https://blueberrywebsites.azureedge.net/bbt/images/Procurement.png",
        sectionClass: "fourth-section"
      }
  ];

  return (
    <>
      <div className="container travel-solutions-section mt-5 pt-md-4 mb-5">
        <div className="row">
          <div className="col-md-12 mt-5">
            <h1 className="text-center headings">
              <span>Our </span> Tourism Services
            </h1>
          </div>
          
          {solutionsData.map((solution, index) => (
            <div key={index} className="row ps-3">
              <div className="col-md-8 mt-md-5 mt-3 paddingL">
                <h3 className={`${solution.sectionClass} headings`}>{solution.title}</h3>
                <div
                  className="bgimage"
                  style={{
                    "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                  }}
                >
                  <p className="mt-4 fs5">{solution.description}</p>
                  {solution.checklistItems.map((item, itemIndex) => (
                    <div key={itemIndex} className="d-flex align-items-center tourism-checklist">
                      <LazyLoadImage
            effect="blur"

                        src='https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/CheckBox.png'
                        alt="checkbox"
                        className="checkbox me-3"
                      />
                      <p className="mb-0">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-4 right-side d-none d-md-block">
                <div className="d-flex justify-content-center mt-2">
                  <LazyLoadImage
            effect="blur"

                    src={solution.image}
                    alt={solution.title}
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default OurTourismServices;